<template>
  <div class="large-text-section" :style="styles">
    <div class="grid grid--container">
      <VText class="large-text-section__text"><slot /></VText>
    </div>
  </div>
</template>

<script>
import {
  VText,
  useTheme,
  getThemeColor,
  getTextColor,
} from '@campsite-bio/component-lib';
import { computed } from '@vue/composition-api';

export default {
  components: {
    VText,
  },

  props: {
    bgColor: {
      type: String,
      default: '#8cccd6',
    },
  },

  setup(props) {
    const theme = useTheme();

    const styles = computed(() => ({
      '--c-bg-color': getThemeColor(props.bgColor, theme.value),
      '--c-text-color': getTextColor(props.bgColor, theme.value),
    }));

    return { styles };
  },
};
</script>

<style lang="scss" scoped>
.large-text-section {
  background-color: var(--c-bg-color);
  padding-bottom: 3rem;
  padding-top: 3rem;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);

  .grid {
    max-width: 700px;
  }
}

.large-text-section__text.large-text-section__text {
  color: var(--c-text-color);
  font-size: 1.5rem;
}
</style>
